import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import Dialog from "@fluentui/react/lib/Dialog";
import { ResourceStrings } from "../../ResourceStrings";
import Button from '../shared/Button'
import Flex from "../shared/Flex";
import JsonEditor, { ValidationSchema } from "./JsonEditor";

export interface EditJsonDialogProps {
    hidden: boolean;
    defaultValue: string;
    validationSchema: ValidationSchema;
    title: string;
    okButtonTitle: string;
    onClose: () => void;
    onOk: (json: string) => void;
}

export default function EditJsonDialog(props: EditJsonDialogProps): JSX.Element {
    const [hasErrors, setHasErrors] = useState(false);
    const [text, setText] = useState("");

    const onCreateClick = (): void => {
        if (!hasErrors) {
            props.onOk(text);
        }
    };

    const hasErrorsChanged = (hasErrors: boolean): void => {
        setHasErrors(hasErrors);
    }

    const textChanged = (newText: string): void => {
        setText(newText);
    }

    return <DialogWrapper
        hidden={props.hidden}
        onDismiss={props.onClose}
        dialogContentProps={{
            showCloseButton: true,
            closeButtonAriaLabel: ResourceStrings.close(),
        }}
    >
        <Container>
            <div className="title-instruction semibold vertical-space">{props.title}</div>

            <JsonEditor
                defaultValue={props.defaultValue}
                validationSchema={props.validationSchema}
                hasErrorsChanged={hasErrorsChanged}
                textChanged={textChanged} />

            <div className="btn-container">
                <Button className="small-space" disabled={hasErrors} onClick={onCreateClick}>{props.okButtonTitle}</Button>
                <Button buttonType="normal" className="small-space" onClick={props.onClose}>Cancel</Button>
            </div>

        </Container>
    </DialogWrapper>
}

const DialogWrapper = styled(Dialog)`
    .ms-Dialog-main {
        min-width: 70%;
        max-width: 100%;
        width: 70%;
    }
    .editor {
        margin-top: 0.5em;
        border: 0.1rem solid #eee;
        border-radius: 0.5rem;
    }
    .editor-ro {
        margin-top: 0.5em;
        border: 0.1rem dashed #666;
        border-radius: 0.5rem;
    }

    .validation {
        height: 10rem;
        overflow-y: scroll;
        margin-bottom: 1em;
    }

    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
    border-radius: .5em;
    padding: 2em;
    margin: 1em 0;
`;

const Container = styled.div`
    position: relative;
    width: 100%;

    .title-instruction {
        font-size: 1.8rem;
        line-height: 2.4rem;
        font-weight: 350;

        .btn-link {
            padding: 0;
            height: auto;
        }
    }

    .title-bar {
        display: flex;
        justify-content: flex-end;
    }

    .red-text {
        color: red;
    }

    .delete-input {
        min-height: 3rem;
    }

    .small-space {
        margin: 0 .5rem;
    }

    .vertical-space {
        margin-bottom: 2rem;
    }

    .btn-container {
        display: flex;
        justify-content: flex-end;
    }
`;

